import MainView from "./UI";
import { UnassignedAccountControllerContextProvider } from "@ui/pages/BusinessUnit/UnassignedAccount/Controller";

const BUUnassignedAccount = () => {
  return (
    <UnassignedAccountControllerContextProvider>
      <MainView />
    </UnassignedAccountControllerContextProvider>
  );
};

export default BUUnassignedAccount;
